import { render } from "./CircleLoader.vue?vue&type=template&id=24f29c0c&scoped=true"
import script from "./CircleLoader.vue?vue&type=script&lang=js"
export * from "./CircleLoader.vue?vue&type=script&lang=js"

import "./CircleLoader.vue?vue&type=style&index=0&id=24f29c0c&scoped=true&lang=scss"

import exportComponent from "/var/www/spom.vh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f29c0c"]])

export default __exports__